import { createFileRoute } from '@tanstack/react-router'

import { PacksPage } from '@/features/packs/packs-page'
import { parsePacksSearch } from '@/features/packs/packs-search'

export const Route = createFileRoute('/_app/packs')({
    validateSearch: parsePacksSearch,
    component: PacksRoute,
    staticData: { crumb: 'Packs' }
})

function PacksRoute() {
    return <PacksPage search={Route.useSearch()} />
}
